// src/components/home/LatestNews.jsx
import React from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../common/ScrollReveal";

const LatestNews = ({
  news = [],
  title = "Latest News",
  moreButtonText = "More News",
  moreButtonUrl = "/news",
}) => {
  if (!news || news.length === 0) {
    return null;
  }

  // Format date to DD-MMM-YYYY format
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <ScrollReveal className="homepage-fade-up-item homepage-fade-up-item--d1">
      <div className="panel-elevated p-4 sm:p-5 md:p-6 h-full flex flex-col rounded-2xl">
        <div className="mb-3 sm:mb-4 pb-2 border-b border-mist-100 flex items-center justify-between">
          <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-brand-foreground tracking-tight">
            {title}
          </h3>
        </div>

        {/* News List */}
        <div className="flex-grow space-y-2.5 sm:space-y-3.5 overflow-y-auto max-h-48 sm:max-h-64 md:max-h-80 pr-1">
          {news
            .slice(-5)
            .reverse()
            .map((item, index) => {
              const to = `/news/${item.documentId || item.id}`;
              const isOddCard = index % 2 === 0;
              const cardToneClass = isOddCard
                ? "border-l-4 border-lake-400/80 hover:bg-lake-50"
                : "border-l-4 border-mist-300/80 hover:bg-mist-50";
              return (
                <ScrollReveal
                  key={item.id || index}
                  className={`homepage-fade-up-item homepage-fade-up-item--d${(index % 4) + 1}`}
                >
                  <Link
                    to={to}
                    className={`group block rounded-sm px-3 py-2 transition-colors duration-150 ${cardToneClass}`}
                  >
                    {item.newsDate && (
                      <p className="text-xs sm:text-sm font-semibold text-mist-500 mb-0.5">
                        {formatDate(item.newsDate)}
                      </p>
                    )}
                    <p className="text-sm sm:text-base text-slate-800 font-medium group-hover:text-lake-500 line-clamp-2">
                      {item.newsTitle}
                    </p>
                  </Link>
                </ScrollReveal>
              );
            })}
        </div>

        {/* More News Button */}
        <div className="mt-3 sm:mt-4 pt-2">
          <Link
            to={moreButtonUrl}
            className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full border border-lake-500/20 text-white text-xs sm:text-sm font-semibold bg-lake-400 hover:bg-lake-500 transition-colors duration-200"
          >
            <span>{moreButtonText}</span>
            <span className="text-[11px] sm:text-xs" aria-hidden="true">
              &#8594;
            </span>
          </Link>
        </div>
      </div>
    </ScrollReveal>
  );
};

export default LatestNews;
